import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import Input from '../Input/Input';
const InputNumber = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className = 'inputNumber',
      allowexponent = true,
      allowdecimal = true,
      allownegativenumber = true
    } = props,
    rest = __rest(props, ["className", "allowexponent", "allowdecimal", "allownegativenumber"]);
  const handleKeyPress = e => {
    if (!allowexponent && e.key === 'e') {
      e.preventDefault();
    }
    if (!allownegativenumber && e.key === '-') {
      e.preventDefault();
    }
    if (!allowdecimal && e.key === '.') {
      e.preventDefault();
    }
  };
  return _jsx(Input, _extends({
    ref: ref,
    type: "number",
    className: className,
    onKeyPress: handleKeyPress
  }, rest));
});
export default InputNumber;